export default function formatHoursAndMinutes(dateAt) {
    const date = new Date(dateAt);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}